import React, { useEffect, useState, useMemo } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { getTrip } from 'redux/actions/UserTrip';
import { dateFormate } from 'utils/utils';
import RideTrackTab from './RideTrackTab';
import { filterRideTrackdata, tripStatusUpdateForm, getStatusUpdateOptions } from './RideTrackData';
import { getCurrentUser } from 'utils/utils';
import CommonDialog from "components/commonDialog/CommonDialog";
import { updateTripStatusApi } from 'services/TripService';
import { toast } from 'react-toastify';

export default function RideTrack() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { state } = useLocation() || {};
  let rideTrackStatus = state;
  
  const params_route = useParams();
  const tabs = params_route?.tabs;
  console.log('Raw useParams:', params_route);
  console.log('tabs value:', tabs, 'type:', typeof tabs);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Convert searchParams to object
  const params = useMemo(() => {
    const obj = {};
    searchParams.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }, [searchParams]);

  // Helper function to get trip type from tab value
  const getTripType = (tabValue) => {
    console.log('getTripType called with:', tabValue);
    const tabString = String(tabValue);
    if (tabString === '3') return 'Rental';
    if (tabString === '4') return 'Airport';
    if (tabString === '9') return 'outStation';
    return 'Ride';
  };
  
  // Initialize states - use useMemo to ensure they're based on current params
  const initialTab = useMemo(() => tabs || '1', [tabs]);
  const initialType = useMemo(() => getTripType(tabs || '1'), [tabs]);
  
  const [value, setValue] = useState(initialTab);
  const [type, setType] = useState(initialType);
  const [page, setPage] = useState(params?.page ? parseInt(params?.page) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(params?.pageSize ? parseInt(params?.pageSize) : 10);
  const [dateFrom, setDateFrom] = useState(params?.startDate ? params?.startDate : '');
  const [dateTo, setDateTo] = useState(params?.endDate ? params?.endDate : '');
  const [status, setStatus] = useState(params?.status ? params?.status : []);
  const [search, setSearch] = useState(params?.search ? params?.search : "");
  
  const tableData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  const [locValue, setLocValue] = useState(null); 
  const [locId, setLocId] = useState(""); 
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [statusUpdateLoading, setStatusUpdateLoading] = useState(false);

  let filterData = {
    id: "",
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    pageSize: rowsPerPage,
    type: type,
    search: search,
    location:selectedLocation?.id // Pass the selected location ID to the API call
  };

  // Effect for initial load and tab changes
  useEffect(() => {
    const currentTab = tabs || '1';
    const tripType = getTripType(currentTab);
    
    setValue(currentTab);
    setType(tripType);
    setPage(0);
  }, [tabs]);

  // Effect for fetching data when filters change
  useEffect(() => {
    const filterData = {
      id: "",
      page: page,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: status,
      pageSize: rowsPerPage,
      type: type,
      search: search,
      location: selectedLocation?.id
    };
    
    dispatch(getTrip(filterData));
  }, [page, rowsPerPage, dateFrom, dateTo, status, search, type, selectedLocation?.id, dispatch]);

  const handleChange = (newValue) => {
    const tripType = {
      trip1: "Ride",
      trip3: "Rental",
      trip4: "Airport",
      trip9: "outStation",
    };

    navigate(`/rideTrack/${newValue}`, { state: rideTrackStatus });

    setStatus(rideTrackStatus?.fromTab === "dashboard" ? status : []);
    setType(tripType[`trip${newValue}`]);
    setValue(newValue);
    setSearch("");

    const filterData = {
      id: "",
      page: page,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: rideTrackStatus?.fromTab === "dashboard" ? status : "",
      pageSize: rowsPerPage,
      type: tripType[`trip${newValue}`],
      search: "",
      location: selectedLocation?.id || ''
    };

    dispatch(getTrip(filterData));
  };

  const onInputChange = (data) => {
    setLocValue(data);
    setLocId(data?.id);
    
    const filterData = {
      id: "",
      page: page,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: status,
      pageSize: rowsPerPage,
      type: type,
      search: search,
      location: data?.id
    };
    
    dispatch(getTrip(filterData));
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
    setSearchParams({ ...params, page: newPage });
    
    const filterData = {
      id: "",
      page: newPage,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: status,
      pageSize: rowsPerPage,
      type: type,
      search: search,
      location: selectedLocation?.id
    };
    
    dispatch(getTrip(filterData));
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setSearchParams({
      ...params,
      page: 0,
      pageSize: newRowsPerPage,
    });
    
    const filterData = {
      id: "",
      page: 0,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: status,
      pageSize: newRowsPerPage,
      type: type,
      search: search,
      location: selectedLocation?.id
    };
    
    dispatch(getTrip(filterData));
  };

  const onClickTableVendor = (data) => {
    const token = getCurrentUser();
    const id = data?.id;

    if (!id) return;

    if (!token) {
      navigate(`/login?redirect=/rideTrack/details/${id}`);
    } else {
      navigate(`/rideTrack/details/${id}`, {
        state: { ...data, id },
      });
    }
  };

  const onFilterChange = (val) => {
    setStatus(val);
    setPage(0);
    setSearchParams({
      ...params,
      status: val.toString(),
      page: 0,
    });
    
    const filterData = {
      id: "",
      page: 0,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: val.toString(),
      pageSize: rowsPerPage,
      type: type,
      search: search,
      location: selectedLocation?.id
    };
    
    dispatch(getTrip(filterData));
  };

  const onRestFilter = () => {
    setStatus("");
    setSearchParams({ ...params, status: '' });
    
    const filterData = {
      id: "",
      page: page,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: "",
      pageSize: rowsPerPage,
      type: type,
      search: search,
      location: selectedLocation?.id
    };
    
    dispatch(getTrip(filterData));
  };

  const onSelectDateRange = (newValue) => {
    let newDateFrom = '';
    let newDateTo = '';
    
    if (newValue === null) {
      setSearchParams({ ...params, startDate: '', endDate: '' });
      setDateFrom('');
      setDateTo('');
    } else {
      newDateFrom = dateFormate(newValue[0], "MM/DD/YYYY");
      newDateTo = dateFormate(newValue[1], "MM/DD/YYYY");
      setSearchParams({
        ...params,
        startDate: newDateFrom,
        endDate: newDateTo,
      });
      setDateFrom(newDateFrom);
      setDateTo(newDateTo);
    }
    
    const filterData = {
      id: "",
      page: page,
      dateFrom: newDateFrom,
      dateTo: newDateTo,
      status: status,
      pageSize: rowsPerPage,
      type: type,
      search: search,
      location: selectedLocation?.id
    };
    
    dispatch(getTrip(filterData));
  };

  const onSearch = debounce((e) => {
    setSearch(e);
    setPage(0);
    setSearchParams({ ...params, search: e, page: 0, pageSize: '' });
    
    const filterData = {
      id: "",
      page: 0,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: status,
      pageSize: '',
      type: type,
      search: e,
      location: selectedLocation?.id
    };
    
    dispatch(getTrip(filterData));
  }, 1000);

  const handleStatusUpdate = async (data) => {
    try {
      setStatusUpdateLoading(true);
      
      const payload = {
        tripId: selectedTrip.tripId,
        status: data.status,
        reason: data.reason || undefined
      };

      const response = await updateTripStatusApi(payload);

      console.log('Trip status update response:', response);
      
      if (response?.success) {
        toast.success('Trip status updated successfully');
        setOpenStatusDialog(false);
        // Refresh trip list
        dispatch(getTrip(filterData));
      } else {
        toast.error(response?.message || 'Failed to update trip status');
      }
    } catch (error) {
      toast.error('Something went wrong while updating trip status');
      console.error('Trip status update error:', error);
    } finally {
      setStatusUpdateLoading(false);
    }
  };

  const onClickMoreIcon = (data, type) => {
    // Only show status update for Ongoing and Closed trips
    if (type === 'Update Status') {
      setSelectedTrip(data);
      setOpenStatusDialog(true);
    }
  };

  let filteredTripData = {
    ...tableData,
    header: tableData?.header,
    body: tableData?.body?.map((trip) => ({...trip, hideaction: ['ongoing', "closed"].includes(trip?.status?.toLowerCase()) ? null : 'true' }))
  }

  return (
    <div>
      <RideTrackTab
        locValue={locValue}
        onInputChange={onInputChange}
        defaultStatus={status}
        filterData={filterRideTrackdata}
        rideTrackData={filteredTripData}
        onClickTableVendor={onClickTableVendor}
        handleChange={handleChange}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        value={value}
        page={page}
        rowsPerPage={rowsPerPage}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        onSelectDateRange={onSelectDateRange}
        loader={loader}
        onSearch={onSearch}
        searchValue={search}
        tabName={'rideTrack'}
        dateFrom={dateFrom}
        dateTo={dateTo}
        onClickMoreIcon={onClickMoreIcon}
        showMoreIcon={true}
      />
      
      {openStatusDialog && (
        <CommonDialog
          open={openStatusDialog}
          handleClose={() => setOpenStatusDialog(false)}
          formData={tripStatusUpdateForm(selectedTrip?.status)} // Pass current status
          button={"dialogButton"}
          onSubmittBtn={handleStatusUpdate}
          type={"Update Trip Status"}
          selectType={"edit"}
          loading={statusUpdateLoading}
          text={`Trip ID: ${selectedTrip?.tripId} currently has the status '${selectedTrip?.status}'. You’re about to update it. Please enter a reason for this update.`}
        />
      )}
    </div>
  );
}


